import React from 'react';
import { ButtonPrimary } from '@americanexpress/dls-react';
import styles from './ErrorView.module.scss';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import LiteralsService from 'src/services/literals/LiteralsService';
import Typography from 'src/components/typography/Typography';

import { DLSSize } from 'src/types/dls-size.enum';
import { useSpendSmartDocumentTitle } from 'src/hooks/useDocumentTitle';
import GlobalFooter from 'src/components/navigation/GlobalFooter';
import GlobalHeader from 'src/components/navigation/GlobalHeader';
import { IconWarning } from '@americanexpress/dls-icons';
import { DlsTypographyVariants } from 'src/types/dls-typography-variants.enum';
import { useHistory } from 'react-router-dom';
import { trackClick, useTrackPage } from 'src/hooks/useAdobeTags';
import SecondaryNavigation from 'src/components/navigation/SecondaryNavigation';
import adobeTags from 'src/types/adobe-tags';
import { goBack } from 'src/services/router.service';
import Loading from 'src/components/atomic/atoms/loading/Loading';
import { retryError } from 'src/utils/error.utils';
import UrlHelper from 'src/utils/url.helper';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import { isMobileApp } from 'src/utils/url.utils';

interface Props {
    reset?: () => void;
    error?: Error;
}

export default function ErrorView({ reset, error }: Props): JSX.Element {
    useSpendSmartDocumentTitle(LiteralsService.getLiteral('Budget.titles.error'));
    useTrackPage(LiteralsService.getLiteral('Budget.titles.error'));
    const history = useHistory();

    const handleBack = (): void => {
        trackClick(UrlHelper.getFullPath('error'), adobeTags.ErrorPage.Back);
        if (reset) {
            reset();
        } else {
            // Timeout to help ensure the click is tracked before the page navigates away
            setTimeout(() => goBack(false, history), 500);
        }
    };

    if (!retryError(error, isMobileApp())) return <Loading />;

    return (
        <div className={styles.errorView}>
            <GlobalHeader />
            <SecondaryNavigation />
            <div className={styles.contentArea} role="main">
                <IconWarning size={DLSSize.LARGE} className={styles.warningIcon} />
                <Typography variant={TypographyVariants.HEADING_S} component="h1">
                    {LiteralsService.getLiteral('Error.anErrorOccurred')}
                </Typography>
                <p className={DlsTypographyVariants.BODY_1}>
                    {LiteralsService.getLiteral('Error.youCanGoBack')}
                    <Anchor
                        tag={adobeTags.ErrorPage.AmericanExpressHomepage}
                        href="https://www.americanexpress.com/"
                        inline
                    >
                        {LiteralsService.getLiteral('Error.americanExpressHomepage')}
                    </Anchor>
                </p>
                <ButtonPrimary size={DLSSize.MEDIUM} className={styles.backButton} onClick={handleBack} autoFocus>
                    {LiteralsService.getLiteral('CommonText.back')}
                </ButtonPrimary>
            </div>
            <GlobalFooter />
        </div>
    );
}
